import { render, staticRenderFns } from "./CmgPepperChatLink.vue?vue&type=template&id=2bec430a&scoped=true&lang=pug"
import script from "./cmg-pepper-chat-link.ts?vue&type=script&lang=ts&external"
export * from "./cmg-pepper-chat-link.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPepperChatLink.vue?vue&type=style&index=0&id=2bec430a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec430a",
  null
  
)

export default component.exports